import type { ReactNode } from 'react';

import { EmptyState, ErrorState, LoadingState } from './State';

interface AsyncState<T> {
  isPending: boolean;
  isError: boolean;
  error: unknown;
  data: T | undefined;
  refetch: () => unknown;
}

interface AsyncContentProps<T> {
  state: AsyncState<T>;
  /** Shown instead of ``children`` when the loaded data is empty. */
  isEmpty?: (data: T) => boolean;
  emptyTitle?: string;
  children: (data: T) => ReactNode;
}

/** Loading, failure with retry, empty and loaded states of one request. */
export function AsyncContent<T>({
  state,
  isEmpty,
  emptyTitle = 'Пока пусто',
  children,
}: AsyncContentProps<T>) {
  if (state.isPending) return <LoadingState />;
  if (state.isError || state.data === undefined) {
    return <ErrorState error={state.error} onRetry={() => void state.refetch()} />;
  }
  if (isEmpty?.(state.data)) return <EmptyState title={emptyTitle} />;
  return <>{children(state.data)}</>;
}
